var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { Step } from '@shared/claim/steps';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import { ExitTypes } from '@shared/types/api/claim';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let ExpertAppointmentByVisioIndex = class ExpertAppointmentByVisioIndex extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/appointment/expertByVisio.svg');
        this.isLoading = false;
    }
    paragraphs() {
        return [
            this.$tc('appointment.expert.visio.verification.description.text.1'),
            this.$tc('appointment.expert.visio.verification.description.text.2'),
            this.$tc('appointment.expert.visio.verification.description.text.3'),
        ];
    }
    async chooseVisioConferenceMode(isVisioConferenceAccepted) {
        this.isLoading = true;
        await this.updateAndSaveClaim({
            step: Step.ExpertAppointmentByVisioVerification,
            claimPayload: { isVisioConferenceAccepted },
        });
        this.isLoading = false;
    }
    async rejectVisioConferenceMode() {
        await this.chooseVisioConferenceMode(false);
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get showHardwareVerification() {
        var _a, _b, _c, _d, _e, _f;
        return ((_f = (_e = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.expertAppointmentByVisioIndex) === null || _d === void 0 ? void 0 : _d.showHardwareVerification) === null || _e === void 0 ? void 0 : _e.includes(this.typeTrigram)) !== null && _f !== void 0 ? _f : false);
    }
    get description() {
        if (this.qualification.irsiApplication === 'non') {
            return this.$tc('appointment.expert.start_screen.description.on_site.irsi');
        }
        if (this.claim.exit === ExitTypes.VisioDistanceAppointment) {
            return this.$tc('appointment.expert.start_screen.description.visio.counting');
        }
        return this.$tc('appointment.expert.start_screen.description.visio.complex');
    }
    get handleButtonAction() {
        return this.showHardwareVerification
            ? async () => {
                await this.acceptAppointment();
                await this.chooseVisioConferenceMode(true);
            }
            : this.acceptAppointment;
    }
    get buttonText() {
        return this.showHardwareVerification
            ? this.$tc('appointment.expert.visio.verification.button.accept')
            : this.$tc('appointment.expert.start_screen.button.accept');
    }
    async acceptAppointment() {
        await this.updateAndSaveClaimStep(Step.ExpertAppointmentByVisioIndex);
    }
};
__decorate([
    claim.Action('updateAndSaveClaimStep')
], ExpertAppointmentByVisioIndex.prototype, "updateAndSaveClaimStep", void 0);
__decorate([
    claim.Action('updateAndSaveClaim')
], ExpertAppointmentByVisioIndex.prototype, "updateAndSaveClaim", void 0);
__decorate([
    claim.State('claim')
], ExpertAppointmentByVisioIndex.prototype, "claim", void 0);
__decorate([
    qualification.State('qualification')
], ExpertAppointmentByVisioIndex.prototype, "qualification", void 0);
__decorate([
    qualification.State('typeTrigram')
], ExpertAppointmentByVisioIndex.prototype, "typeTrigram", void 0);
__decorate([
    settings.Getter('setting')
], ExpertAppointmentByVisioIndex.prototype, "setting", void 0);
ExpertAppointmentByVisioIndex = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
            goBack: null,
        },
    })
], ExpertAppointmentByVisioIndex);
export default ExpertAppointmentByVisioIndex;
